import service from '@/activity/activity-service';
import Roles from '@/auth/roles';

export default {
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true,
    user: null
  },

  getters: {
    loading: (state) => state.loading,
    list: (state) => state.list,
    last: (state) => state.last,
    user: (state) => state.user,
    hasRoleToFullHistory: (
      state,
      getters,
      rootState,
      rootGetters
    ) => (activity) => {
      if (!activity.entityPath) {
        return false;
      }

      const roles = Roles.values;

      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    LAST(state, payload) {
      state.last = !!payload;
    },

    USER(state, payload) {
      state.user = payload;
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
    }
  },

  actions: {
    setup({ commit, dispatch }, user) {
      commit('CLEAR');
      commit('USER', user);
      return dispatch('fetch');
    },

    fetch({ commit, getters, dispatch }) {
      commit('LOADING', true);

      const lastmodified =
        getters.list && getters.list.length
          ? getters.list[getters.list.length - 1].modified
          : 10000000000000;

      return service
        .fetch(getters.user.id, lastmodified)
        .then((response) => {
          commit('LAST', response.last);
          commit(
            'LIST',
            getters.list.concat(response.data)
          );
          commit('LOADING', false);
        })
        .catch((error) => {
          dispatch('shared/error', error, { root: true });
          commit('LOADING', false);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    }
  }
};



// WEBPACK FOOTER //
// ./src/activity/activity-store.js